import { TableRowDisplayEvent, DataSourceExecutionEvent, DataSourceAction } from "@mcleod/components";
import { AutogenLayoutMasterCodeControlList } from "./autogen/AutogenLayoutMasterCodeControlList";
import { MaskTooltipHelper } from "./MaskTooltipHelper";

export class MasterCodeControlList extends AutogenLayoutMasterCodeControlList {
    sourceAutogenAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            if (event.dataSource.data.length > 0)
                MaskTooltipHelper.setTooltipData(event.dataSource.summaryData.get("mask_legend", []));
        }
    }

    tableAutogenOnRowDisplay(event: TableRowDisplayEvent) {
        event.getTableRow()?.findComponentsByField("mask")?.forEach(component => {
            MaskTooltipHelper.setTooltipContent(component);
        });
    }
}
